module.exports = __webpack_public_path__ + "img/FlatFare.067319cc.svg";